import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

import { buildBlogPosting } from 'lib/LDJson';
import { shareImage } from 'lib/social';
import { getCanonical } from 'lib/urlUtils';

function constructMetaData(card, vertical) {
  const {
    cardData: {
      teaseImage: cardTeaseImage,
    } = {},
    description,
    headline,
    primaryImage,
    socialImage,
    teaseImage,
    url,
    nativeAd,
    searchable,
  } = card;

  // Image
  const image = cardTeaseImage || socialImage || teaseImage || primaryImage || {};
  const imageUrl = (image.url && image.url.primary);

  return (
    <Head>
      <title>{headline.seo || headline.primary}</title>
      <meta name="description" content={description.seo || description.primary} />
      <link rel="canonical" href={getCanonical(url)} />

      <meta property="og:url" content={url} />
      <meta property="og:title" content={headline.social || headline.primary} />
      <meta property="og:description" content={description.primary || description.seo} />

      <meta property="og:image" content={shareImage(imageUrl, vertical, 'og')} />
      <meta property="og:image:secure_url" content={shareImage(imageUrl, vertical, 'og')} />
      <meta property="og:image:type" content={image.encodingFormat || 'image/gif'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:type" content="article" />

      <meta name="twitter:image:src" content={shareImage(imageUrl, vertical, 'twitter')} />
      <meta name="twitter:image" content={shareImage(imageUrl, vertical, 'twitter')} />
      <meta name="twitter:title" content={headline.social || headline.primary} />
      <meta name="twitter:description" content={description.primary || description.seo} />
      <meta name="twitter:card" content="summary_large_image" />

      <meta name="thumbnail" content={shareImage(imageUrl, vertical)} />
      {(nativeAd || !searchable) && <meta name="ROBOTS" content="NOINDEX, NOFOLLOW" />}
    </Head>
  );
}

function CardMetadata({ card, vertical }) {
  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: `${JSON.stringify(buildBlogPosting(card))}` }}
        />
      </Head>

      {constructMetaData(card, vertical)}
    </>
  );
}

CardMetadata.propTypes = {
  card: PropTypes.objectOf(PropTypes.any).isRequired,
  vertical: PropTypes.string.isRequired,
};

export default CardMetadata;
